import { currentStageType } from "@/lib/stages";

// Quick "waiting at stage" filter chips, shared by the Schedule and Work Orders tabs.
export const STAGE_FILTERS = [
  { key: "all", label: "All", dot: "bg-slate-400" },
  { key: "in_house", label: "In-House", dot: "bg-blue-500" },
  { key: "osp", label: "OSP", dot: "bg-orange-500" },
  { key: "assembly", label: "Assembly", dot: "bg-violet-500" },
  { key: "done", label: "Completed", dot: "bg-emerald-500" },
];

// Filter a list of orders by the stage type they are currently waiting at.
export function stageFilterApply(orders = [], value = "all") {
  return value === "all" ? orders : orders.filter((o) => currentStageType(o) === value);
}

export function StageFilterChips({ orders = [], value, onChange, containerTestid = "stage-filters", itemPrefix = "stage-filter", label = "Waiting at" }) {
  if (!orders.length) return null;
  const counts = orders.reduce((acc, o) => {
    const t = currentStageType(o);
    if (t) acc[t] = (acc[t] || 0) + 1;
    return acc;
  }, {});
  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={containerTestid}>
      <span className="text-[11px] uppercase tracking-wide text-slate-400 font-semibold mr-1">{label}</span>
      {STAGE_FILTERS.map((f) => {
        const count = f.key === "all" ? orders.length : counts[f.key] || 0;
        const on = value === f.key;
        return (
          <button
            key={f.key}
            onClick={() => onChange(f.key)}
            data-testid={`${itemPrefix}-${f.key}`}
            aria-pressed={on}
            className={`inline-flex items-center gap-1.5 h-7 pl-2 pr-2.5 rounded-full text-xs font-medium border transition-colors ${on ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-200 hover:border-slate-300 hover:bg-slate-50"}`}
          >
            <span className={`h-2 w-2 rounded-full ${f.dot}`} />
            {f.label}
            <span className={`font-mono-data text-[10px] ${on ? "text-slate-300" : "text-slate-400"}`}>{count}</span>
          </button>
        );
      })}
    </div>
  );
}
